<h1 mat-dialog-title>{{ dialogTitle }}</h1>

<mat-dialog-content>
  <app-packaging-components-overview #packagingComponentsTable [dataSource]="dataSource" [displayedColumns]="displayedColumns" [componentCategoryId]="componentCategoryId"
    [isUserValidator]="false">
  </app-packaging-components-overview>
</mat-dialog-content>

<mat-dialog-actions>
  <button (click)="importComponents(true)" mat-raised-button type="submit" color="primary"
    [disabled]="packagingComponentsTable.selectedComponentIds.length === 0 || isDataExchangeSubRequest">
    {{ 'component.addWithTracking' | transloco }}</button>
  <button (click)="importComponents(false)" mat-raised-button type="submit" color="primary"
    [disabled]="packagingComponentsTable.selectedComponentIds.length === 0">
    {{ 'component.addWithoutTracking' | transloco }}</button>
  <button (click)="closeDialog()" mat-raised-button type="button">
    {{ 'common.buttons.cancel' | transloco }}</button>
</mat-dialog-actions>
